import swal from "sweetalert2";

function alertSuccess(opt = {}) {
    const defaultOpt = {
        title: '成功',
        text: '操作成功',
        icon: 'success'
    };
    return swal.fire(Object.assign(defaultOpt, opt));
}

function alertError(err, opt = {}) {
    try {
        const defaultOpt = {
            title: '錯誤',
            html: err.response.data.error.message,
            icon: 'error',
            confirmButtonColor: '#126EFD'
        };

        swal.fire(Object.assign(defaultOpt, opt));
    } catch (e) {
        console.error(err);
    }
}

export {alertSuccess, alertError};